import * as React from 'react';
import type { ApolloError } from '@apollo/client';
import { Mutation } from '@apollo/client/react/components';

import { CHANGE_USER_PASSWORD } from './gql/changeUserPassword.gql';

type Props = {
  children: (arg0: {
    changePassword: (arg1: ChangeUserPasswordInput) => Promise<any>;
    error?: ApolloError;
    loading: boolean;
  }) => React.ReactElement | null;
  onCompleted?: () => void;
};

export const ChangeUserPasswordMutation = ({
  children,
  onCompleted,
}: Props) => (
  <Mutation<ChangeUserPassword, ChangeUserPasswordVariables>
    mutation={CHANGE_USER_PASSWORD}
    onCompleted={onCompleted}
    // Add an onError so a failed mutation doesn't throw an unresolved promise
    onError={() => {}}
  >
    {(change, { error, loading }) => {
      const changePassword = (input: ChangeUserPasswordInput) =>
        change({
          variables: {
            input,
          },
        });

      return children({
        changePassword,
        error,
        loading,
      });
    }}
  </Mutation>
);
